import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../api.service';
import { CommonService } from '../common.service';
var CasePracticePAndOComponent = (function () {
    function CasePracticePAndOComponent(route, router, apiService, commonService) {
        this.route = route;
        this.router = router;
        this.apiService = apiService;
        this.commonService = commonService;
        this.isTencent = false; // 用于判断是否为腾讯对接
    }
    CasePracticePAndOComponent.prototype.ngOnInit = function () {
        var _this = this;
        // ---Stephen add 2025-03-07---
        // 添加是否腾讯对接的判断
        this.isTencent = this.commonService.checkAndSetModuleId();
        console.log(this.isTencent, '🚚🚚🚚🚚🚚🚚');
        // -------------------------------------------------------------------
        this.userType = window.sessionStorage.getItem('userType');
        this.route.queryParams.subscribe(function (queryParams) {
            _this.type = queryParams['type'];
        });
        this.route.params.subscribe(function (params) {
            _this.learningPathId = params['learningPathId'];
            _this.practiceMetaId = params['practiceMetaId'];
            _this.exerciseId = params['exerciseId'];
            if (_this.exerciseId > 0 || localStorage.getItem('isIframe')) {
                _this.page = 'previous';
            }
            else {
                _this.page = 'list';
            }
            _this.apiService.ajax({
                'type': 'GET',
                'url': '/sr/createAndGet/' + _this.learningPathId + '/' + _this.practiceMetaId
            }).subscribe(function (result) {
                _this.practiceList = result.exercise;
                _this.practiceId = result.id;
                _this.apiService.ajax({
                    'type': 'post',
                    'url': 'sr/practice/correctLearningPath/' + _this.practiceId,
                    'data': { 'practiceId': _this.practiceId }
                }).subscribe(function (result) {
                    console.log(result);
                });
            });
            /*this.page = 'event';
            this.practiceList = this.getMockData().exercise;
            this.practiceId = this.getMockData().id;*/
        });
        setTimeout(function () {
            if (_this.type) {
                $('#userIdContainer').val(JSON.parse(localStorage.getItem('userInfo'))['userId']);
            }
        }, 500);
    };
    CasePracticePAndOComponent.prototype.goToEvent = function () {
        this.page = 'event';
    };
    CasePracticePAndOComponent.prototype.setPracticeIndex = function (i) {
        this.practiceIndex = i;
        this.exerciseId = this.practiceList[this.practiceIndex].id;
    };
    CasePracticePAndOComponent.prototype.goToNextStep = function (i) {
        if (i == 1) {
            this.page = 'previous';
        }
        else {
            this.page = 'event';
        }
    };
    return CasePracticePAndOComponent;
}());
export { CasePracticePAndOComponent };



// WEBPACK FOOTER //
// ./src/app/case-practice-p-and-o/case-practice-p-and-o.component.ts.pre-build-optimizer.js